<script setup lang="ts">
  import type { SuperUserOrganisation as Organisation } from '@/types/generated'
  import { computed, defineProps } from 'vue'
  import { getColorForString, getInitials } from '@/lib/utils'

  const props = defineProps({
    org: {
      type: Object as () => Organisation,
      required: true
    },
    small: {
      type: Boolean,
      default: false
    }
  })

  const avatarColor = computed(() => {
    return `bg-${getColorForString(props.org.name)}-600`
  })

  const initials = computed(() => {
    return getInitials(props.org.name)
  })
</script>

<template>
  <div
    class="relative mr-2 inline-flex items-center justify-center overflow-hidden rounded-full text-white"
    :class="`${small ? 'h-6 w-6' : 'h-10 w-10'} ${avatarColor}`"
  >
    <span class="font-medium text-white">
      {{ initials }}
    </span>
  </div>
  <span class="text-sm text-gray-600">
    {{ org.name }}
  </span>
</template>
